import React, { PureComponent } from 'react';
import { Link } from 'react-router-dom';

class MobileButton extends PureComponent {
    render() {
        const { gender, ageGroup, postcode, sector, jobRating, unionMember, submitResults } = this.props;
        
        return (
            <div className="row">
                <div className="col-lg-6 offset-lg-6">
                    <div className="formwrap-mobbutton">
                        {gender && ageGroup && postcode && sector && jobRating && unionMember ? (
                                <Link to="/results" onClick={(e) => submitResults()} className="button" >
                                    SEE RESULTS
                                </Link>
                            ) : (
                            <div className="button __disabled" >
                                SEE RESULTS
                            </div>
                            )
                        }
                    </div>
                </div>
            </div>
        );
    }
}

export default MobileButton;


// WEBPACK FOOTER //
// ./src/Form/MobileButton.js